"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textColorOndanger = exports.textColorDanger = exports.textColorOnbranded = exports.textColorBranded = exports.textColorInverse = exports.textColorDisabled = exports.textColorSecondary = exports.textColorPrimary = exports.motionColorPrimaryOnbranded = exports.motionColorPrimaryBranded = exports.controlColorDangerEnabled = exports.controlColorSecondaryDisabled = exports.controlColorSecondarySelectedHover = exports.controlColorSecondarySelected = exports.controlColorSecondaryHover = exports.controlColorSecondaryEnabled = exports.controlColorPrimaryDisabled = exports.controlColorPrimarySelectedHover = exports.controlColorPrimarySelected = exports.controlColorPrimaryHover = exports.controlColorPrimaryEnabled = exports.actionColorInverseDisabled = exports.actionColorInversePressed = exports.actionColorInverseHover = exports.actionColorInverseEnabled = exports.actionColorSecondaryDisabled = exports.actionColorSecondaryPressed = exports.actionColorSecondaryHover = exports.actionColorSecondaryEnabled = exports.actionColorDangerDisabled = exports.actionColorDangerPressed = exports.actionColorDangerHover = exports.actionColorDangerEnabled = exports.actionColorVisitedHover = exports.actionColorVisitedEnabled = exports.actionColorTertiaryPressed = exports.actionColorTertiaryHover = exports.actionColorPrimaryDisabled = exports.actionColorPrimaryPressed = exports.actionColorPrimaryHover = exports.actionColorPrimaryEnabled = exports.baseGradientFadein = exports.baseGradientFadeout = exports.baseColorOverlay = exports.baseColorHighest = exports.baseColorHigh = exports.baseColorNormal = exports.baseColorLow = exports.baseColorLowest = exports.baseColorFlat = void 0;
exports.colorRed50 = exports.colorRed40 = exports.colorRed30 = exports.colorRed20 = exports.colorRed10 = exports.skeletonColorAnimation = exports.labelColorDisabled = exports.labelColorFocused = exports.labelColorEnabled = exports.loadingspinnerColorSecondaryOnbranded = exports.loadingspinnerColorSecondaryBranded = exports.illustrationColorDanger = exports.illustrationColorSecondary = exports.illustrationColorPrimary = exports.borderColorInverse = exports.borderColorHigh = exports.borderColorNormal = exports.feedbackColorDisabledLow = exports.feedbackColorDisabledHigh = exports.feedbackColorWarningLow = exports.feedbackColorWarningHigh = exports.feedbackColorInfoLow = exports.feedbackColorInfoHigh = exports.feedbackColorSuccessLow = exports.feedbackColorSuccessHigh = exports.feedbackColorDangerLow = exports.feedbackColorDangerHigh = exports.feedbackColorBrandedLow = exports.feedbackColorBrandedHigh = exports.iconColorOninfo = exports.iconColorInfo = exports.iconColorOnsuccess = exports.iconColorSuccess = exports.iconColorOndanger = exports.iconColorDanger = exports.iconColorOnbranded = exports.iconColorBranded = exports.iconColorInverse = exports.iconColorDisabled = exports.iconColorSecondary = exports.iconColorPrimary = exports.switchColorInactiveDisabled = exports.switchColorInactiveHover = exports.switchColorInactiveEnabled = exports.switchColorActiveHover = exports.switchColorActiveDisabled = exports.textColorOninfo = exports.textColorInfo = exports.textColorOnsuccess = exports.textColorSuccess = void 0;
exports.colorGrey50 = exports.colorGrey40 = exports.colorGrey30 = exports.colorGrey20 = exports.colorGrey10 = exports.colorBlue05 = exports.colorBlue90 = exports.colorBlue80 = exports.colorBlue70 = exports.colorBlue60 = exports.colorBlue50 = exports.colorBlue40 = exports.colorBlue30 = exports.colorBlue20 = exports.colorBlue10 = exports.colorTurquoise05 = exports.colorTurquoise90 = exports.colorTurquoise80 = exports.colorTurquoise70 = exports.colorTurquoise60 = exports.colorTurquoise50 = exports.colorTurquoise40 = exports.colorTurquoise30 = exports.colorTurquoise20 = exports.colorTurquoise10 = exports.colorGreen05 = exports.colorGreen90 = exports.colorGreen80 = exports.colorGreen70 = exports.colorGreen60 = exports.colorGreen50 = exports.colorGreen40 = exports.colorGreen30 = exports.colorGreen20 = exports.colorGreen10 = exports.colorYellow05 = exports.colorYellow90 = exports.colorYellow80 = exports.colorYellow70 = exports.colorYellow60 = exports.colorYellow50 = exports.colorYellow40 = exports.colorYellow30 = exports.colorYellow20 = exports.colorYellow10 = exports.colorRed05 = exports.colorRed90 = exports.colorRed80 = exports.colorRed70 = exports.colorRed60 = void 0;
exports.colorHeroRed05 = exports.colorHeroRed90 = exports.colorHeroRed80 = exports.colorHeroRed70 = exports.colorHeroRed60 = exports.colorHeroRed50 = exports.colorHeroRed40 = exports.colorHeroRed30 = exports.colorHeroRed20 = exports.colorHeroRed10 = exports.colorPink05 = exports.colorPink90 = exports.colorPink80 = exports.colorPink70 = exports.colorPink60 = exports.colorPink50 = exports.colorPink40 = exports.colorPink30 = exports.colorPink20 = exports.colorPink10 = exports.colorUltraViolet05 = exports.colorUltraViolet90 = exports.colorUltraViolet80 = exports.colorUltraViolet70 = exports.colorUltraViolet60 = exports.colorUltraViolet50 = exports.colorUltraViolet40 = exports.colorUltraViolet30 = exports.colorUltraViolet20 = exports.colorUltraViolet10 = exports.colorPurple05 = exports.colorPurple90 = exports.colorPurple80 = exports.colorPurple70 = exports.colorPurple60 = exports.colorPurple50 = exports.colorPurple40 = exports.colorPurple30 = exports.colorPurple20 = exports.colorPurple10 = exports.colorGrey00 = exports.colorGrey01 = exports.colorGrey05 = exports.colorGrey95 = exports.colorGrey90 = exports.colorGrey80 = exports.colorGrey70 = exports.colorGrey60 = void 0;
exports.baseColorFlat = '#242424';
exports.baseColorLowest = '#333333';
exports.baseColorLow = '#1E1E1E';
exports.baseColorNormal = '#6B6B6B';
exports.baseColorHigh = '#DBDBDB';
exports.baseColorHighest = '#F4F4F4';
exports.baseColorOverlay = '#161616cc';
exports.baseGradientFadeout = 'linear-gradient(180deg, #161616 0%, #16161600 100%)';
exports.baseGradientFadein = 'linear-gradient(180deg, #16161600 0%, #161616 100%)';
exports.actionColorPrimaryEnabled = '#8FB3E9';
exports.actionColorPrimaryHover = '#BBD1F2';
exports.actionColorPrimaryPressed = '#6295E0';
exports.actionColorPrimaryDisabled = '#333333';
exports.actionColorTertiaryHover = '#ffffff14';
exports.actionColorTertiaryPressed = '#ffffff29';
exports.actionColorVisitedEnabled = '#C9B8E8';
exports.actionColorVisitedHover = '#D9CCEF';
exports.actionColorDangerEnabled = '#EC8086';
exports.actionColorDangerHover = '#F2A5A9';
exports.actionColorDangerPressed = '#E8656C';
exports.actionColorDangerDisabled = '#333333';
exports.actionColorSecondaryEnabled = '#8fb3e914';
exports.actionColorSecondaryHover = '#8fb3e93d';
exports.actionColorSecondaryPressed = '#8fb3e952';
exports.actionColorSecondaryDisabled = '#16161614';
exports.actionColorInverseEnabled = '#242424';
exports.actionColorInverseHover = '#333333';
exports.actionColorInversePressed = '#1E1E1E';
exports.actionColorInverseDisabled = '#333333';
exports.controlColorPrimaryEnabled = '#4D4D4D';
exports.controlColorPrimaryHover = '#6B6B6B';
exports.controlColorPrimarySelected = '#8FB3E9';
exports.controlColorPrimarySelectedHover = '#BBD1F2';
exports.controlColorPrimaryDisabled = '#4D4D4D';
exports.controlColorSecondaryEnabled = '#16161603';
exports.controlColorSecondaryHover = '#8fb3e90a';
exports.controlColorSecondarySelected = '#8fb3e914';
exports.controlColorSecondarySelectedHover = '#8fb3e91f';
exports.controlColorSecondaryDisabled = '#ffffff0a';
exports.controlColorDangerEnabled = '#EC8086';
exports.motionColorPrimaryBranded = '#8FB3E9';
exports.motionColorPrimaryOnbranded = '#F9F9F9';
exports.textColorPrimary = '#FFFFFF';
exports.textColorSecondary = '#DBDBDB';
exports.textColorDisabled = '#A3A3A3';
exports.textColorInverse = '#161616';
exports.textColorBranded = '#8FB3E9';
exports.textColorOnbranded = '#161616';
exports.textColorDanger = '#EC8086';
exports.textColorOndanger = '#161616';
exports.textColorSuccess = '#A3DA70';
exports.textColorOnsuccess = '#161616';
exports.textColorInfo = '#6295E0';
exports.textColorOninfo = '#161616';
exports.switchColorActiveDisabled = '#6B6B6B';
exports.switchColorActiveHover = '#BBD1F2';
exports.switchColorInactiveEnabled = '#6B6B6B';
exports.switchColorInactiveHover = '#A3A3A3';
exports.switchColorInactiveDisabled = '#4D4D4D';
exports.iconColorPrimary = '#FFFFFF';
exports.iconColorSecondary = '#DBDBDB';
exports.iconColorDisabled = '#A3A3A3';
exports.iconColorInverse = '#161616';
exports.iconColorBranded = '#8FB3E9';
exports.iconColorOnbranded = '#161616';
exports.iconColorDanger = '#EC8086';
exports.iconColorOndanger = '#161616';
exports.iconColorSuccess = '#A3DA70';
exports.iconColorOnsuccess = '#161616';
exports.iconColorInfo = '#6295E0';
exports.iconColorOninfo = '#161616';
exports.feedbackColorBrandedHigh = '#8FB3E9';
exports.feedbackColorBrandedLow = '#417FDA';
exports.feedbackColorDangerHigh = '#F7C9CB';
exports.feedbackColorDangerLow = '#EC8086';
exports.feedbackColorSuccessHigh = '#DFF2CD';
exports.feedbackColorSuccessLow = '#B3E088';
exports.feedbackColorInfoHigh = '#EEF4FC';
exports.feedbackColorInfoLow = '#8FB3E9';
exports.feedbackColorWarningHigh = '#FEF7E0';
exports.feedbackColorWarningLow = '#FADE80';
exports.feedbackColorDisabledHigh = '#DBDBDB';
exports.feedbackColorDisabledLow = '#4D4D4D';
exports.borderColorNormal = '#333333';
exports.borderColorHigh = '#4D4D4D';
exports.borderColorInverse = '#242424';
exports.illustrationColorPrimary = '#6295E0';
exports.illustrationColorSecondary = '#F4F4F4';
exports.illustrationColorDanger = '#EC8086';
exports.loadingspinnerColorSecondaryBranded = '#161616';
exports.loadingspinnerColorSecondaryOnbranded = '#16161629';
exports.labelColorEnabled = 'linear-gradient(180deg, #24242410 0%, #242424 50%, #24242400 100%)';
exports.labelColorFocused = 'linear-gradient(180deg, #24242410 0%, #242424 5%, #333333 60%, #33333300 100%)';
exports.labelColorDisabled = 'linear-gradient(180deg, #33333310 0%, #333333 50%, #33333300 100%)';
exports.skeletonColorAnimation = 'linear-gradient(-90deg, #6b6b6b00 0%, #6b6b6bd6 50%, #6b6b6b00 100%)';
exports.colorRed10 = '#F7C9CB';
exports.colorRed20 = '#F2A5A9';
exports.colorRed30 = '#EC8086';
exports.colorRed40 = '#E8656C';
exports.colorRed50 = '#E44B52';
exports.colorRed60 = '#E5434A';
exports.colorRed70 = '#D73D45';
exports.colorRed80 = '#D1323A';
exports.colorRed90 = '#C82A32';
exports.colorRed05 = '#FCE9EA';
exports.colorYellow10 = '#FDEBB2';
exports.colorYellow20 = '#FADE80';
exports.colorYellow30 = '#F7D14D';
exports.colorYellow40 = '#F5C825';
exports.colorYellow50 = '#F3BD02';
exports.colorYellow60 = '#F3B701';
exports.colorYellow70 = '#F1AE00';
exports.colorYellow80 = '#EFA600';
exports.colorYellow90 = '#EC9800';
exports.colorYellow05 = '#FEF7E0';
exports.colorGreen10 = '#DFF2CD';
exports.colorGreen20 = '#C9E9AB';
exports.colorGreen30 = '#B3E088';
exports.colorGreen40 = '#A3DA70';
exports.colorGreen50 = '#93D357';
exports.colorGreen60 = '#8BCE4F';
exports.colorGreen70 = '#7FC847';
exports.colorGreen80 = '#76C23D';
exports.colorGreen90 = '#64B72C';
exports.colorGreen05 = '#F2FAEB';
exports.colorTurquoise10 = '#B4E6E0';
exports.colorTurquoise20 = '#80D6CB';
exports.colorTurquoise30 = '#4CC6B6';
exports.colorTurquoise40 = '#26B9A6';
exports.colorTurquoise50 = '#00AD96';
exports.colorTurquoise60 = '#02A68E';
exports.colorTurquoise70 = '#019C83';
exports.colorTurquoise80 = '#029379';
exports.colorTurquoise90 = '#048670';
exports.colorTurquoise05 = '#E1F5F2';
exports.colorBlue10 = '#BBD1F2';
exports.colorBlue20 = '#8FB3E9';
exports.colorBlue30 = '#6295E0';
exports.colorBlue40 = '#417FDA';
exports.colorBlue50 = '#2067D3';
exports.colorBlue60 = '#1C5ECE';
exports.colorBlue70 = '#1654C8';
exports.colorBlue80 = '#124AC2';
exports.colorBlue90 = '#0A39B7';
exports.colorBlue05 = '#EEF4FC';
exports.colorGrey10 = '#DBDBDB';
exports.colorGrey20 = '#C2C2C2';
exports.colorGrey30 = '#A3A3A3';
exports.colorGrey40 = '#878787';
exports.colorGrey50 = '#6B6B6B';
exports.colorGrey60 = '#4D4D4D';
exports.colorGrey70 = '#333333';
exports.colorGrey80 = '#242424';
exports.colorGrey90 = '#1E1E1E';
exports.colorGrey95 = '#161616';
exports.colorGrey05 = '#F4F4F4';
exports.colorGrey01 = '#F9F9F9';
exports.colorGrey00 = '#FFFFFF';
exports.colorPurple10 = '#D9CCEF';
exports.colorPurple20 = '#C9B8E8';
exports.colorPurple30 = '#BAA3E2';
exports.colorPurple40 = '#9B7AD5';
exports.colorPurple50 = '#8C66CF';
exports.colorPurple60 = '#7C52C8';
exports.colorPurple70 = '#6D3DC2';
exports.colorPurple80 = '#563099';
exports.colorPurple90 = '#4B2A84';
exports.colorPurple05 = '#F7F5FC';
exports.colorUltraViolet10 = '#CBCCF1';
exports.colorUltraViolet20 = '#A8AAE2';
exports.colorUltraViolet30 = '#9997E5';
exports.colorUltraViolet40 = '#8885E4';
exports.colorUltraViolet50 = '#7673CE';
exports.colorUltraViolet60 = '#5A5CBE';
exports.colorUltraViolet70 = '#4D4FB9';
exports.colorUltraViolet80 = '#292B8A';
exports.colorUltraViolet90 = '#23255F';
exports.colorUltraViolet05 = '#EFEFFF';
exports.colorPink10 = '#FDF2F7';
exports.colorPink20 = '#FAD9E7';
exports.colorPink30 = '#F6B2CF';
exports.colorPink40 = '#ED66A0';
exports.colorPink50 = '#FF2B85';
exports.colorPink60 = '#E21B70';
exports.colorPink70 = '#C21760';
exports.colorPink80 = '#A11350';
exports.colorPink90 = '#790A3A';
exports.colorPink05 = '#FFF8FB';
exports.colorHeroRed10 = '#FCDCDE';
exports.colorHeroRed20 = '#FABABC';
exports.colorHeroRed30 = '#F5757A';
exports.colorHeroRed40 = '#F25259';
exports.colorHeroRed50 = '#D61F26';
exports.colorHeroRed60 = '#C60F16';
exports.colorHeroRed70 = '#AB191E';
exports.colorHeroRed80 = '#950B11';
exports.colorHeroRed90 = '#64070B';
exports.colorHeroRed05 = '#FEF1F2';